<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示</div>
      <div class="tips-details">
        <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
        <div class="no">
          2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
        </div>
        <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
        <div class="no">
          4.域见未来单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
        </div>  
      </div>
    </div>
    <div>
      <navStepList
        style="justify-content: center; margin: 40px 0"
        :value="navStepList"
        :current="navStepCurrent"
        :lineWidth="40"
      ></navStepList>
    </div>
    <template v-if="navStepCurrent === 0">
      <div>
        <div class="bj-search-section">
          <div class="bj-search-row">
            <div class="item">
              <div class="name" style="margin-right: 10px">发票类型：</div>
              <Select
                class="bj-select-h45 bj-bg-color-26262A"
                v-model="searchObj.invoiceType"
                style="width: 180px"
                clearable
              >
                <Option
                  v-for="item in invoiceTypeLists"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </div>
            <div class="item">
              <div class="name" style="margin-right: 10px">交易时间：</div>
              <DatePicker
                class="bj-bg-color-26262A date-time-h45"
                v-model="searchObj.startAtStr"
                format="yyyy-MM-dd"
                type="daterange"
                placement="bottom-end"
                placeholder="交易时间"
                style="width: 240px"
                @on-change="onStartAtChange"
              ></DatePicker>
            </div>
            
          </div>
          <div class="bj-search-row" style="margin-top: 20px">
            <div class="item" style="margin-right: 60px">
              <div class="name" style="margin-right: 10px">可开票金额：</div>
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="searchObj.startMoney"
                placeholder="开始可开票金额"
                style="width: 120px"
                @on-keyup="searchObj.startMoney = searchObj.startMoney.replace(/[^\d^\.]+/g,'')"
                clearable
              />
              <span style="color: #fff">-</span>
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="searchObj.endMoney"
                placeholder="结束可开票金额"
                @on-keyup="searchObj.endMoney = searchObj.endMoney.replace( /[^\d^\.]+/g,'')"
                style="width: 120px"
                clearable
              />
            </div>
            <div class="item">
              <Button class="bj-search-btn-F85A36"
                type="primary"
                style="margin-right: 20px"
                @click="onSearch"
                >搜索</Button
              >
              <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
            </div>
          </div>
          <div class="bj-price-panl" style="margin-top: 30px;">
            <div class="bj-price-panls">
              <div class="item">
                <div class="name" style="margin-right: 10px">可开票金额：</div>
                <div class="label" style="margin-right: 10px">{{ availableAmount }}</div>
              </div>
              <div class="item">
                <div class="name" style="margin-right: 10px">开票金额：</div>
                <div class="label" style="margin-right: 10px">{{ totalInvoiceAmount }}</div>
              </div>
              <div class="item">
                <div class="name" style="margin-right: 10px">已开票金额：</div>
                <div class="label" style="margin-right: 10px">{{ usedAmount }}</div>
              </div>
              <div class="item">
                <div class="name" style="margin-right: 10px">已选开票金额：</div>
                <div class="label" style="margin-right: 10px">{{ selectTotal || 0 }}</div>
              </div>
            </div>
            <Button shape="circle" class="bj-search-btn-F85A36" style="width: 100px" @click="onAdd">申请发票</Button>
          </div>
          <div class="bj-rows content-start">
            <div :class="['nav mr-20', { navActive: searchObj.timeType === 0 }]" @click="selectNav(0)">本月可开</div>
            <div :class="['nav mr-20', { navActive: searchObj.timeType === 1 }]" @click="selectNav(1)">下月可开</div>
            <div :class="['nav', { navActive: searchObj.timeType === 2 }]" @click="selectNav(2)">已开票记录</div>
          </div>
        </div>
        
        <div class="bj-table-data">
          <Table
            class="bj-2F3033-table"
            stripe
            :columns="columns"
            :data="data"
            :loading="tableLoading"
            @on-selection-change="onSelectionChange"
          >
            <template slot="remark" slot-scope="{ row }">
              <div class="table-btn" @click="onShowRemark(row.desc)">查看备注</div>
            </template>
          </Table>
          <div class="page-tool">
            <Page
              class="pages"
              :current="searchObj.page"
              :total="searchObj.total"
              :page-size="searchObj.limit"
              show-total
              show-sizer
              show-elevator
              @on-change="onPageChange"
              @on-page-size-change="onPageSizeChange"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="navStepCurrent === 1">
      <div class="tips-sections">
        <div class="bj-rows content-between" style="flex: 1">
          <div>
            <div class="tips">您选取了<span class="no">{{selectList.length}}</span>条单据开具发票</div>
            <div style="color: #737577">(若选中多条记录，金额将合并开具在一张票据中)</div>
          </div>
          <div>
            <div>已选开票金额：</div>
            <div class="price">￥{{selectTotal}}</div>
          </div>
        </div>
        <div class="d-table">
          <div class="d-item">
            <div class="d-item-name required">发票信息</div>
            <div class="d-item-value">
              <Select
                class="bj-select-h45 bj-bg-color-26262A"
                v-model="form.invoiceId"
                filterable
                style="width: 250px"
                placeholder="请选择"
                @on-change="infoChange"
              >
                <Option
                  v-for="item in invoiceInfoList"
                  :key="item.id"
                  :value="item.id"
                  >{{
                    `${item.header} - ${
                      item.t == 0 ? "个人" : "企业"
                    } - ${
                      item.tt == 0
                        ? "增值税普通发票"
                        : "增值税专用发票"
                    }`
                  }}</Option
                >
              </Select>
            </div>
          </div>
          <template v-if="form.invoiceId">
            <div class="d-item">
              <div class="d-item-name required">开具类型</div>
              <div class="d-item-value">
                <RadioGroup v-model="invoiceInfoType.issueType">
                  <Radio class="bj-color-F85A36" :label="0" disabled>个人</Radio>
                  <Radio class="bj-color-F85A36" :label="1" disabled>企业</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="d-item">
              <div class="d-item-name required">发票类型</div>
              <div class="d-item-value">
                <RadioGroup v-model="invoiceInfoType.invoiceType">
                  <Radio class="bj-color-F85A36" :label="0" disabled>个人</Radio>
                  <Radio class="bj-color-F85A36" :label="1" disabled>企业</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="d-item">
              <div class="d-item-name required">发票抬头</div>
              <div class="d-item-value">
                <Input
                  class="bj-input-26262A bj-input-h45"
                  disabled
                  v-model="form.title"
                  placeholder="发票抬头"
                  style="width: 300px"
                  clearable
                />
              </div>
            </div>
          </template>
          <div class="d-item">
            <div class="d-item-name required">发票内容</div>
            <div class="d-item-value">
              <RadioGroup v-model="form.contentType">
                <Radio class="bj-color-F85A36" :label="0">域名服务费</Radio>
                <Radio class="bj-color-F85A36" :label="1">信息服务费</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">收件人</div>
            <div class="d-item-value">
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="form.recipient"
                placeholder="收件人"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">手机号码</div>
            <div class="d-item-value">
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="form.mobile"
                placeholder="手机号码"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">收件人地址</div>
            <div class="d-item-value">
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="form.address"
                placeholder="收件人地址"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name">邮编</div>
            <div class="d-item-value">
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="form.postcode"
                placeholder="邮编"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name">备注</div>
            <div class="d-item-value">
              <Input
                class="bj-input-26262A bj-input-h45"
                v-model="form.remark"
                placeholder="备注"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
        </div>
        <div class="rows" style="margin-left: 20px">
          <RadioGroup v-model="form.expressPaymentType">
            <Radio
              class="bj-color-F85A36" 
              :label="0"
              :disabled="$store.state.balance < (form.expressAmount || 0)"
              >快递{{ form.expressAmount || 0 }}元（当前可用余额：{{
                $store.state.balance || 0
              }}元)</Radio
            >
            <Radio class="bj-color-F85A36" :label="1" style="margin-left: 20px">到付（顺丰）</Radio>
          </RadioGroup>
        </div>
        <div class="rows" style="margin-top: 20px; margin-left: 20px">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onConfirm"
            >提交申请</Button
          >
          <Button class="bj-border-F85A36" @click="backCancel">返回上一步</Button>
          <Checkbox class="bj-color-F85A36" v-model="form.isDefault" style="margin-left: 20px">
            设置默认信息</Checkbox
          >
        </div>
      </div>
    </template>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
  </div>
</template>

<script>
import navStepList from "components/navStepList";
import {
  invoiceTypeList,
  invoiceInvoiceAmountList,
  invoiceTotalInvoiceAmount,
  invoiceDefault,
  invoiceInfoMore,
  applyMakeInvoice,
} from "api/user.js";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
export default {
  name: "invoiceapply",
  components: {
    navStepList,
    pushRemarkModal,
  },
  data() {
    return {
      navStepList: [
        "选择开票订单",
        "填写发票信息和地址",
        "后台审核，邮寄发票",
        "签收快递，开票成功",
      ],
      invoiceTypeLists: [],
      navStepCurrent: 0,
      searchObj: {
        startAtStr: [],
        endAt: "",
        endMoney: "",
        invoiceType: null,
        limit: 20,
        page: 1,
        startAt: "",
        startMoney: "",
        timeType: 0,
      },
      columns: [
        {
          type: "selection",
          align: "center",
        },
        {
          width: 170,
          title: "申请时间",
          key: "createdTime",
          align: "center",
        },
        {
          title: "类型",
          key: "type",
          align: "center",
        },
        {
          title: "交易金额",
          key: "money",
          align: "center",
        },
        {
          title: "可开票金额",
          key: "invoiceAmount",
          align: "center",
        },
        {
          title: "备注",
          ellipsis: true,
          slot: "remark",
          align: "center",
        },
      ],
      availableAmount: "",
      totalInvoiceAmount: "",
      usedAmount: "",
      selectTotal: "",
      data: [],
      tableLoading: false,
      pushRemarkModalVisibility: false,
      remark: "", // 备注内容
      defaultDetail: {}, // 默认发票
      invoiceInfoList: [], // 发票信息查询全部
      form: {
        invoiceId: "",
        title: "",
        contentType: 0,
        recipient: "",
        mobile: "",
        address: "",
        postcode: "",
        remark: "",
        isDefault: false,
        expressPaymentType: 0,
        expressAmount: null,
      },
      selectList: [], // 选中的域名
    };
  },
  computed: {
    invoiceInfoType() {
      for (const i in this.invoiceInfoList) {
        if (this.invoiceInfoList[i].id === this.form.invoiceId) {
          return {
            issueType: this.invoiceInfoList[i].issueType,
            invoiceType: this.invoiceInfoList[i].invoiceType,
          };
        }
      }
      return {
        issueType: null,
        invoiceType: null,
      };
    },
  },
  created() {
    this.req_invoiceTypeList();
    this.req_invoiceTotalInvoiceAmount();
    this.req_getList();
  },
  methods: {
    // 请求类型
    async req_invoiceTypeList() {
      const { code, data } = await invoiceTypeList();
      if (code === 200) {
        let tempArray = data.map((o) => {
          return { value: o.invoice, label: o.name };
        });
        this.invoiceTypeLists = tempArray || [];
      }
    },
    // 获取发票总金额
    async req_invoiceTotalInvoiceAmount() {
      const { code, data } = await invoiceTotalInvoiceAmount();
      if (code === 200) {
        this.availableAmount = data.can || 0;
        this.totalInvoiceAmount = data.total || 0;
        this.usedAmount = data.could || 0;
      }
    },
    // 默认发票
    async req_invoiceDefault() {
      const { code, data, result } = await invoiceDefault();
      if (code === 200 && data != null && result) {
        if (data.invoiceId) {
          this.form.invoiceId = data.invoiceId;
          this.form.title = data.header;
          this.form.contentType = data.contentType;
          this.form.recipient = data.recipient;
          this.form.mobile = data.phone;
          this.form.address = data.address;
          this.form.postcode = data.postcode;
          this.form.isDefault = data.isDefault;
        }
        this.form.expressAmount = data.expressFee;
      }
    },
    // 发票信息查询全部
    async req_invoiceInfoMore() {
      const { code, data } = await invoiceInfoMore();
      if (code === 200) {
        this.invoiceInfoList = data;
      }
    },
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          endTime: this.searchObj.endAt,
          startTime: this.searchObj.startAt,
          total: "",
          amount: "",
        };
        this.searchObj.invoiceType !== -1 &&
          (params.type = this.searchObj.invoiceType);
        this.tableLoading = true;
        const { code, data } = await invoiceInvoiceAmountList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 申请发票
    async req_applyMakeInvoice() {
      const params = {
        ids: this.selectList.map((item) => item.id),
        invoiceId: this.form.invoiceId,
        title: this.form.title,
        contentType: this.form.contentType,
        recipient: this.form.recipient,
        phone: this.form.mobile,
        address: this.form.address,
        postCode: this.form.postcode,
        remark: this.form.remark,
        isDefault: this.form.isDefault ? 1 : 0,
        expressType: this.form.expressPaymentType,
        expressFee: this.form.expressAmount,
      };
      const { code, result } = await applyMakeInvoice(params);
      if (code === 200 && result) {
        this.$Message.success("申请提交成功，您的申请将在后台审核！");
        this.form = this.$options.data().form;
        this.navStepCurrent = 0;
      }
    },
    // 提交申请
    onConfirm() {
      if (this.selectList.length <= 0) {
        this.$Message.warning("请选择开票订单！");
        this.active = 1;
        this.clearAll();
        return;
      }
      if (!this.form.invoiceId) {
        this.$Message.warning("请输入选择发票信息！");
        return;
      }
      if (!this.form.recipient) {
        this.$Message.warning("请输入收件人！");
        return;
      }
      if (!this.form.mobile) {
        this.$Message.warning("请输入手机号码！");
        return;
      }
      if (!this.form.address) {
        this.$Message.warning("请输入收件人地址！");
        return;
      }
      this.req_applyMakeInvoice();
    },
    // 返回上一步
    backCancel() {
      this.form = this.$options.data().form;
      this.navStepCurrent = 0;
      this.onPageChange(1);
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 日期改变
    onStartAtChange(event) {
      this.searchObj.startAt = event[0];
      this.searchObj.endAt = event[1];
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
    // 申请发票
    onAdd() {
      if (!this.selectList || this.selectList.length <= 0) {
        this.$Message.warning("您未选择任何可开发票！");
        return;
      }
      this.req_invoiceInfoMore();
      this.req_invoiceDefault();
      this.navStepCurrent = 1;
    },
    // 开票类型
    selectNav(val) {
      this.searchObj.timeType = val;
      this.onPageChange(1);
    },
    // 发票信息选择改变
    infoChange() {
      for (const i in this.invoiceInfoList) {
        if (this.invoiceInfoList[i].id === this.form.invoiceId) {
          this.form.title = this.invoiceInfoList[i].title;
          return;
        }
      }
    },
    // 选中
    onSelectionChange(val) {
      this.selectList = val;
      this.selectTotal = val.reduce((pre, nextVal) => {
        return pre + nextVal.availableAmount || 0;
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
  .tips-section {
  background-color: #28292C;
  border-radius: 6px;
  display: flex;
  margin-top: 20px;
  .title {
    width: 80px;
    height: 160px;
    color: #fff;
    font-size: 16px;
    background-color: #4E312D;
    padding: 30px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .tips-details{
    padding: 28px 23px 10px;
    .no {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
    }
  }
  
}
  .bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    margin-top: 30px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .bj-price-panl{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #737577;
    padding: 20px 0;
    .bj-price-panls{
      flex: 1;
      display: flex;
      .item{
        flex: 1;
        .name{
          color: #737577;
        }
        .label{
          color: #fff;
          font-size: 18px;
          margin-top: 10px;
        }
      }
    }
  }
  .nav{
    height: 40px;
    line-height: 40px;
    margin: 0 30px;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
  }
  .nav.navActive{
    color: #F85A36;
  }
  .tips-sections{
    background-color: #28292C;
    border-radius: 6px;
    padding: 32px;
    color: #fff;
    .no{
      padding: 0 4px;
      font-size: 18px;
      color: #F85A36;
    }
    .price{
      font-size: 18px;
      color: #F85A36;
      font-weight: bold;
    }
  }
  .d-table{
    width: 100%;
    border-top: 1px solid #737577;
    padding-top: 20px;
    margin-top: 20px;
    .d-item{
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .d-item-name{
        min-width: 120px;
        text-align: right;
        margin-right: 20px;
      }
    }
  }
</style>

